import React, { useState, useEffect, useContext } from 'react';
import Breadcrumb from '../../shared/Breadcrumb';
import Util from '../../../Util';
import { apiRoutes } from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import alertify from "alertifyjs";

const Checkout = (props) => {
    const doctor = JSON.parse(props.location.state.selectedDoctor);
	const selectedTime = props.location.state.selectedTime;
	const { userState } = useContext(AuthContext);
	const history = useHistory();
	const patient = userState.loggedInUser;
	const [charges, setCharges] = useState({});
	const [isConrifmButtonDisabled, setIsConrifmButtonDisabled] = useState(false);

	const selectedDateAndTime = {
        day: selectedTime.split('_')[0],
        month: parseInt(selectedTime.split('_')[1]) - 1,
        year: selectedTime.split('_')[2],
        date: new Date(selectedTime.split('_')[2], (parseInt(selectedTime.split('_')[1]) - 1), selectedTime.split('_')[0]),
        time: selectedTime.split('_')[3]
	};

	const initialRequest = {
		appoinmentId: 0,
		appoinmentDate: Util.getDateStringForPost(selectedDateAndTime.date),
		appoinmentTime: selectedDateAndTime.time,
		doctorId: doctor.doctorId,
		patientId: patient.patientId,
        totalAmount: 0,
		purpose: '',
		paymentMethodId: 1
	}

	const [appoinmentRequest, setAppoinmentRequest] = useState(initialRequest);

	const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };
	
	useEffect(() => {
		axios.get(apiRoutes.getVisitingCharges + doctor.doctorId, options)
        .then((response) => {
            if(response.status === 200)
            {
				const data = response.data;
				setCharges(data.data);
				setAppoinmentRequest({...appoinmentRequest, 
					totalAmount:  data.data.consultingFee + data.data.bookingFee + data.data.videoCallFee,
				})
            }
        }, (error) => {
			alertify.error("Doctor charges are not setup, Cannot book appoinment this time");
			setIsConrifmButtonDisabled(true);
        });
	}, []);	

	const handleSubmit = e => {
		e.preventDefault();
		console.log(appoinmentRequest);

		axios.post(apiRoutes.createAppoinment, JSON.stringify(appoinmentRequest), options)
		.then((response) => {
		 	 if(response.status === 200)
		  	{
			  	console.log(response)
				const data = response.data;
				if(data.success)
				{
					history.push({
						pathname: '/bookingsuccess',
						state: { 
							doctor: JSON.stringify(doctor), 
							appoinmentDate: Util.getFormatDate({date: selectedDateAndTime.date}), 
							appoinmentTime: selectedDateAndTime.time, 
							appoinmentResult: JSON.stringify(data.appoinment) 
						}
					})
				}
			}
	   }, (error) => {
			alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
	   });
	}

    return ( 
        <div>
            <Breadcrumb title="Checkout" />
            <div className="content">
				<div className="container">
					<div className="row">
						<div className="col-md-7 col-lg-8">
							<div className="card">
								<div className="card-body">
									<form onSubmit={(e) => handleSubmit(e)}>
										<div className="info-widget">
											<h4 className="card-title">Purpose of Visit</h4>
											<div className="row">
												<div className="col-md-12 col-sm-12">
													<div className="form-group card-label">
														<label>Reason</label>
														<input
															className="form-control"
															type="text"
															required
															onChange={e => setAppoinmentRequest({...appoinmentRequest, purpose: e.target.value})} />
													</div>
												</div>
											</div>
										</div>
										<div className="payment-widget">
											<h4 className="card-title">Payment Method</h4>
											<div className="payment-list">
												<label className="payment-radio paypal-option">
													<input 
														type="radio" 
														name="radio"
														checked
														onChange={e => setAppoinmentRequest({...appoinmentRequest, paymentMethodId: 4 })} />
													<span className="checkmark"></span>
													Cash
												</label>
											</div>
											<div className="terms-accept">
												<div className="custom-checkbox">
												   <input type="checkbox" id="terms_accept" checked />
												   <label htmlFor="terms_accept">I have read and accept <a href="#">Terms &amp; Conditions</a></label>
												</div>
											</div>
											
											<div className="submit-section mt-4">
												<button type="submit" className="btn btn-primary submit-btn" disabled={isConrifmButtonDisabled}>Confirm and Pay</button>
											</div>
											
										</div>
									</form>
									
								</div>
							</div>
							
						</div>
						
						<div className="col-md-5 col-lg-4 theiaStickySidebar">
						
							<div className="card booking-card">
								<div className="card-header">
									<h4 className="card-title">Booking Summary</h4>
								</div>
								<div className="card-body">
								
									<div className="booking-doc-info">
										<a href="doctor-profile.html" className="booking-doc-img">
											<img src={Util.loadImage(doctor.profileImage)} alt="User Image" />
										</a>
										<div className="booking-info">
                                            <h4><a href="doctor-profile.html">Dr. {doctor.firstName} {doctor.lastName}</a></h4>
											<div className="rating">
												<i className="fas fa-star filled"></i>
												<i className="fas fa-star filled"></i>
												<i className="fas fa-star filled"></i>
												<i className="fas fa-star filled"></i>
												<i className="fas fa-star"></i>
												<span className="d-inline-block average-rating">35</span>
											</div>
											<div className="clinic-details">
												<p className="doc-location"><i className="fas fa-map-marker-alt"></i> {doctor.state}, {doctor.country}</p>
											</div>
										</div>
									</div>
									
									<div className="booking-summary">
										<div className="booking-item-wrap">
											<ul className="booking-date">
                                                <li>Date <span>{Util.getFormatDate({date: selectedDateAndTime.date})}</span></li>
                                                <li>Time <span>{selectedDateAndTime.time}</span></li>
											</ul>
											<ul className="booking-fee">
												<li>Consulting Fee <span>${charges.consultingFee} </span></li>
												<li>Booking Fee <span>${charges.bookingFee}</span></li>
												<li>Video Call <span>${charges.videoCallFee}</span></li>
											</ul>
											<div className="booking-total">
												<ul className="booking-total-list">
													<li>
														<span>Total</span>
														<span className="total-cost">${ appoinmentRequest.totalAmount }</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>

				</div>

			</div>		
			
        </div>
    );
}
 
export default Checkout;